<template>
  <AppsflyerLinkGeneratorCore />
</template>

<script>
import AppsflyerLinkGeneratorCore from './AppsflyerLinkGeneratorCore.vue'

export default {
  name: 'AppsflyerLinkGenerator',
  components: { AppsflyerLinkGeneratorCore },
}
</script>
